import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function InstagramAdsPage() {
  useEffect(() => {
    // Add noindex meta tag dynamically
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (metaRobots) {
        metaRobots.setAttribute('content', 'index, follow');
      }
    };
  }, []);
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-570" data-mp="1l80kxrclouqg">
      
      <Navigation data-id="element-571" data-mp="1q13cjtxthu40" />

      <main data-id="element-572" data-mp="1q1mxzkmof0ms">
        <Hero data-id="element-573" data-mp="25ci9fuvsjxvt" />
        <Consultation data-id="element-574" data-mp="25c8qusd2st05" />
      </main>

      <Footer data-id="element-575" data-mp="25da6la51e3o7" />
      <CookieBanner data-id="element-576" data-mp="25cryng90i10g" />
    </div>;
}